'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _AddressList = require('../AddressList');

var _AddressList2 = _interopRequireDefault(_AddressList);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _Button = require('../../../FormInput/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _react.PropTypes.arrayOf,
    shape = _react.PropTypes.shape,
    string = _react.PropTypes.string,
    func = _react.PropTypes.func;
var AddressBookIndex = (_dec = (0, _reactCssModules2.default)(_style2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AddressBookIndex, _React$Component);

  function AddressBookIndex() {
    (0, _classCallCheck3.default)(this, AddressBookIndex);
    return (0, _possibleConstructorReturn3.default)(this, (AddressBookIndex.__proto__ || (0, _getPrototypeOf2.default)(AddressBookIndex)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressBookIndex, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Select your ',
          this.props.addressType,
          ' address'
        ),
        _react2.default.createElement(_AddressList2.default, {
          selectedAddressId: this.props.selectedAddressId,
          addresses: this.props.addresses,
          onEdit: this.props.onEdit,
          onDelete: this.props.onDelete,
          onChoice: this.props.onChoice
        }),
        _react2.default.createElement(
          'a',
          {
            href: '#!',
            styleName: 'add-address-link',
            onClick: this.props.onAdd
          },
          'Add new address'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'button-bar' },
          _react2.default.createElement(
            _Button2.default,
            { onClick: this.props.onSelect },
            'Select'
          )
        )
      );
    }
  }]);
  return AddressBookIndex;
}(_react2.default.Component), _class2.propTypes = {
  onAdd: func.isRequired,
  onEdit: func.isRequired,
  onSelect: func.isRequired,
  onChoice: func.isRequired,
  onDelete: func.isRequired,
  selectedAddressId: string,
  addressType: string.isRequired,
  addresses: arrayOf(shape({
    firstName: string.isRequired,
    lastName: string.isRequired,
    company: string.isRequired,
    address1: string.isRequired,
    address2: string.isRequired,
    city: string.isRequired,
    state: string.isRequired,
    postcode: string.isRequired
  }))
}, _temp)) || _class);
exports.default = AddressBookIndex;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/AddressBookIndex/index.js
// module id = 2256
// module chunks = 0